import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import RestrictedPageWithCanViewQuery, {
	type RestrictedPageWithCanViewQuery$data,
	type RestrictedPageWithCanViewQuery$variables,
} from './__generated__/RestrictedPageWithCanViewQuery.graphql.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export function preloadRequestViewQuery(id: string): Promise<{
	data: RestrictedPageWithCanViewQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query<RestrictedPageWithCanViewQuery$data, RestrictedPageWithCanViewQuery$variables>({
		query: RestrictedPageWithCanViewQuery,
		variables: { id },
	});
}
